import { render } from "./article-slider-model.vue?vue&type=template&id=3f93bd7f"
import script from "./article-slider-model.vue?vue&type=script&lang=js"
export * from "./article-slider-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__